import { createContext } from 'reka-ui'
import type { AccessRole } from '@gat-ship/types'
import type { AccessRoleDetailService } from '@gat-ship/types/injection-keys'

export interface ShowChangeAccessRoleNameDialogParams {
  accessRole: AccessRole
}

export interface ShowDeleteAccessRoleDialogParams {
  accessRole: AccessRole
}

export interface AccessRoleDetailProviderContext {
  dataSource: AccessRoleDetailService
  modals: {
    showChangeAccessRoleName: (
      params: ShowChangeAccessRoleNameDialogParams
    ) => void
    showDeleteAccessRole: (params: ShowDeleteAccessRoleDialogParams) => void
  }
}

export const [useAccessRoleDetailProvider, provideAccessRoleDetail] =
  createContext<AccessRoleDetailProviderContext>('access-role-detail-provider')
